import { match } from 'ts-pattern'

import { DocumentTypeOption } from '../../types'

export function getShouldHideClassification(selectedDocumentType: DocumentTypeOption | null) {
  return match(selectedDocumentType)
    .with(DocumentTypeOption.OTHER, DocumentTypeOption.OFFER_LETTER, () => true)
    .otherwise(() => false)
}
